import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AppSettings } from '../../helpers/config';
import { MessageService } from '../../helpers/message.service'; // mensajes
import { TokenService } from './token.service'; // mensajes
import { GeneralService } from '../../helpers/general.service';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable()
export class AuthenticationService {
    public AppSettings = new AppSettings;
    private tipo: number;

    constructor(private http: HttpClient, private messageService: MessageService
        , public tokenService: TokenService, public generalService: GeneralService) {
        // set token if saved in local storage
        //let currentUser = JSON.parse(localStorage.getItem('currentUser'));        
        //this.tokenService.setToken(currentUser && currentUser.token);
    }
    login(username: string, password: string): Observable<boolean> {
        const body = new HttpParams()
            .set('email', username)
            .set('pass', password);

        return this.http.post(this.AppSettings.URL + 'login/access',
            body.toString(),
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        ).map((response: result_server) => {
            // login successful if there's a jwt token in the response           
            let tipo = response.tipo;
            this.messageService.add(response.msg);
            if (tipo === 1) {
                // set token property
                this.tokenService.setToken(response.info);

                // store username and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify({ username: username, token: response.info }));

                // return true to indicate successful login
                // this.generalService.ChkMenu();
                return true;
            } else {
                // return false to indicate failed login
                return false;
            }
        });       
    }    

    logout(): void {
        // clear token remove user from local storage to log user out
        this.tokenService.setToken(null);
        localStorage.removeItem('currentUser');
    }
    /**
    * Handle Http operation that failed.
    * Let the app continue.
    * @param operation - name of the operation that failed
    * @param result - optional value to return as the observable result
    */
    private handleError<T> (operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

        // TODO: send the error to remote logging infrastructure
        console.error(error); // log to console instead

        // TODO: better job of transforming error for user consumption
        this.log(`${operation} failed: ${error.message}`);

        // Let the app keep running by returning an empty result.
        return of(result as T);
        };
    }
    private log(message: string) {
        console.log(message);
    }
}

interface result_server {
    tipo: number;
    msg: string ;
    info: string;
}


// WEBPACK FOOTER //
// /home/estandar/web/tuhogaronline.tk/public_html/adminTHO/src/app/components/auth/authentication.service.ts